<template>
  <section class="section">
    <h1>References</h1>
    <Loader v-if="loading" />
    <failed-to-load v-if="!loading && failed" />
    <div class="reference-grid" v-else>
      <study-reference-item
        v-for="item in references"
        :key="item.id"
        :reference="item"
      />
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import StudyReferenceItem from './StudyReferenceItem';
import Loader from '@/components/global/Loader';
import FailedToLoad from '@/components/global/FailedToLoad';

export default {
  name: 'study-references',
  components: { StudyReferenceItem, Loader, FailedToLoad },
  data: function() {
    return {
      failed: false,
      loading: false,
    };
  },
  mounted() {
    this.getReferencesHandler();
  },
  methods: {
    ...mapActions('study', ['getReferences']),
    async getReferencesHandler() {
      this.loading = true;
      const response = await this.getReferences(this.$route.params.id);
      if (response && response.status >= 300) {
        this.failed = true;
      }
      this.loading = false;
    },
  },
  computed: {
    ...mapState('study', {
      references: state => state.references,
      referencesStudyId: state => state.referencesStudyId,
    }),
  },
};
</script>

<style lang="scss" scoped>
.reference-grid {
  display: grid;
  gap: 1px;
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 4rem;

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: 1366px) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
